import React, { useState } from "react";
import {
  Link,
  Tooltip,
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkIcon from "@mui/icons-material/Link";
import HelpIcon from "@mui/icons-material/Help";

function Footer(props: any) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const { page } = props;

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleClick = () => {
    setDialogOpen(true);
  };

  const helpText = () => {
    if (page === 0) {
      return (
        <p>
          <div>
            「ぶいすぽ非公式wiki用構文ジェネレータ」では、ぶいすぽ非公式wiki用の各種構文を生成・コピーすることができます。
          </div>
          <ul>
            <li>
              「顔サムネ+リンク生成」では、「配信者名」ドロップダウンリストから名前を選択することで、「wiki用書式」欄に生成された構文が出力されます。右のボタンをクリックすると欄内の文字列をクリップボードにコピーすることができます。
            </li>
            <li>
              「(各配信サイト)+リンク生成」では、各配信のURLを入力し、「Search」をクリックすることで、「wiki用配信タイトル+リンク」欄に生成された構文が出力されます。右のボタンをクリックすると欄内の文字列をクリップボードにコピーすることができます。
            </li>
          </ul>
        </p>
      );
    }
    if (page === 1) {
      return (
        <p>
          <div>
            「Youtube配信予定」では、直近のYoutube配信枠を確認できるほか、ぶいすぽ非公式wiki用の配信スケジュール用の構文を生成することができます。
          </div>
          <div>
            各サムネイルはYoutubeのリンクになっています。また、各サムネイル右下のカレンダーアイコンをクリックすることでぶいすぽ非公式wiki用の構文を生成することができます。
          </div>
          <div>
            配信開始予定時刻が現在から48時間前以後の配信枠が一覧に表示されます。配信開始予定時刻が後のものが上に表示されます。
          </div>
          <div>
            配信データ収集は自動で行っておりますが、ぶいすぽメンバーの全ての配信を掲載できるわけではないのでご了承下さい。データは30分に一度更新されます。
          </div>
        </p>
      );
    }
    return <p>Error</p>;
  };

  return (
    <Box
      p="0.5rem"
      sx={{
        backgroundColor: "#FFFFFF",
        marginTop: "auto",
        textAlign: "center",
      }}
      boxShadow={3}
    >
      <div>
        <Tooltip title="本ページに関する問い合わせ・要望等はこちら">
          <IconButton size="large">
            <Link
              href="https://twitter.com/svet_gg"
              style={{ textAlign: "center" }}
            >
              <TwitterIcon color="action" />
            </Link>
          </IconButton>
        </Tooltip>
        <Tooltip title="ぶいすぽ非公式wiki">
          <IconButton size="large">
            <Link href="https://wikiwiki.jp/vspo">
              <LinkIcon color="action" />
            </Link>
          </IconButton>
        </Tooltip>
        <Tooltip title="ヘルプ">
          <IconButton onClick={handleClick} size="large">
            <HelpIcon color="action" />
          </IconButton>
        </Tooltip>
        <Dialog open={dialogOpen} onClose={handleClose}>
          <DialogTitle>当サイトについて</DialogTitle>
          <DialogContent>
            <a href="https://wikiwiki.jp/vspo/">ぶいすぽ非公式wiki</a>のための、
            <a href="https://wikiwiki.jp/sample/">wikiwikiのルール</a>
            に則った書式を出力するwebアプリです。意見・要望等は
            <a href="https://twitter.com/svet_gg">作者</a>までお願いします。
            {helpText()}
          </DialogContent>
        </Dialog>
      </div>
      <Link href="/term_and_policy" variant="caption">
        利用規約/プライバシーポリシー
      </Link>
    </Box>
  );
}

export default Footer;
